(function () {
  if (window.__mrblueAnimationsReady) return;
  window.__mrblueAnimationsReady = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function revealAll(nodes) {
    nodes.forEach(reveal);
  }

  function autoStagger(container, selector) {
    var children = container.querySelectorAll(selector);
    children.forEach(function (child, index) {
      if (child.classList.contains('mrblue-animate')) return;
      child.classList.add('mrblue-animate');
      child.style.transitionDelay = Math.min(index * 0.07, 0.42) + 's';
    });
    return children;
  }

  function init() {
    var items = document.querySelectorAll('.mrblue-animate');

    document.querySelectorAll('.mrblue-trend-hero .mrblue-animate, .mrblue-landing .mrblue-animate').forEach(function (el, index) {
      window.setTimeout(function () {
        reveal(el);
      }, 80 + index * 120);
    });

    document.querySelectorAll('.mrblue-cat-grid, .mrblue-perks').forEach(function (wrap) {
      autoStagger(wrap, ':scope > *');
    });

    items = document.querySelectorAll('.mrblue-animate');

    if (!items.length || reduceMotion) {
      revealAll(items);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      revealAll(items);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          window.requestAnimationFrame(function () {
            reveal(entry.target);
          });
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -4% 0px',
        threshold: 0.06
      }
    );

    items.forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });

    window.setTimeout(function () {
      document.querySelectorAll('.mrblue-animate:not(.is-visible)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          reveal(el);
        }
      });
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function toggleShopifyChat(hide) {
    var selectors = [
      '#shopify-chat',
      '#ShopifyChat',
      '#dummy-chat-button-iframe',
      'inbox-online-store-chat'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (hide) {
          node.style.setProperty('display', 'none', 'important');
          node.style.setProperty('visibility', 'hidden', 'important');
          node.style.setProperty('pointer-events', 'none', 'important');
          node.style.setProperty('opacity', '0', 'important');
        } else {
          node.style.removeProperty('display');
          node.style.removeProperty('visibility');
          node.style.removeProperty('pointer-events');
          node.style.removeProperty('opacity');
        }
      });
    });
  }

  function syncShopifyChatWithCart() {
    var isOpen =
      document.body.classList.contains('mini-cart--open') ||
      document.body.classList.contains('mini-cart--opening') ||
      !!document.querySelector('.cart-drawer-container[open]');
    toggleShopifyChat(isOpen);
  }

  function watchCartChat() {
    syncShopifyChatWithCart();

    new MutationObserver(syncShopifyChatWithCart).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    var drawer = document.querySelector('cart-drawer details');
    if (drawer) {
      new MutationObserver(syncShopifyChatWithCart).observe(drawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartChat);
  } else {
    watchCartChat();
  }
})();
